import { Pipe, PipeTransform, Input } from '@angular/core';
import { AuthService } from '../services/auth.service';
import * as _ from 'lodash';
import { normalizeCaseAndAccents } from '../utils/functions';
import moment from 'moment';
import { DateService } from '../services/date.service';
import levenshtein from 'js-levenshtein';

@Pipe({ name: 'sort', pure: false })
export class SortPipe implements PipeTransform {

    constructor() {
    }

    transform(items, sortConfig) {
        if (sortConfig && sortConfig.key && sortConfig.order) {
            return sortConfig.order === 1 ? this.sort(items, sortConfig.key, sortConfig.subkey) : _.reverse(this.sort(items, sortConfig.key, sortConfig.subkey))
        } else {
            return _.reverse(items);
        }
    }

    sort(items, key, subkey) {
        return _.sortBy(items, (i) => {
            if (_.isArray(i[key])) {
                if (i[key].length > 0) {
                    return _.get(i[key], `[0][${subkey}]`);
                }
                else {
                    return null;
                }
            }
            else {
                return subkey ? _.get(i, key + "." + subkey) : i[key];
            }


        })
    }
}